/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElSelect as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElRadioGroup as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { ElInputNumber as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input-number/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElDivider as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("基础配置");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("活动期间有效");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("领取后 ");
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 天过期");
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发放规则配置");
const _hoisted_6 = /*#__PURE__*/_createTextVNode("直接发放");
const _hoisted_7 = /*#__PURE__*/_createTextVNode("活动发放");
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "直接发放：指选择部分玩家直接发放代金券"), /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "活动发放：所有玩家在活动时间内满足一次规则，即向该玩家发放一张代金券")], -1);
const _hoisted_9 = /*#__PURE__*/_createTextVNode("单日累充");
const _hoisted_10 = /*#__PURE__*/_createTextVNode("单笔消费");
const _hoisted_11 = /*#__PURE__*/_createTextVNode("活动累充");
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 元 ");
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "在活动时间内，任意一日累计实付金额达到规定金额，即向该玩家发放代金券", -1);
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 元 ");
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "在活动时间内，任意一笔不使用代金券的消费实付金额达到规定金额，即向该玩家发放代金券", -1);
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 元 ");
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "在活动时间内,累计实付金额达到规定金额，即向该玩家发放代金券", -1);
const _hoisted_18 = /*#__PURE__*/_createTextVNode("所有订单");
const _hoisted_19 = /*#__PURE__*/_createTextVNode("不含优惠订单");
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "选择被刺活动计费（计算累充/单笔消费）是否包含使用代金券的订单", -1);
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 每人 ");
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 张 ");
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "活动期间，至多可参与活动次数", -1);
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 张 ");
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "当代金券数量被领取完，玩家在活动时间内满足活动规则也不再获得代金券", -1);
const _hoisted_26 = {
  class: "dialog-footer"
};
const _hoisted_27 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_28 = /*#__PURE__*/_createTextVNode("确定");
import FileSaver from 'file-saver';
import UUpload from '@ultra/share/components/UUpload/index.vue';
import DateRangePicker from '@ultra/share/components/DateRangePicker/index.vue';
import { apiUsdkAddVoucher, apiUsdkEditVoucher } from '@/api/usdk';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const dialogVisible = ref(false);
    const type = ref('add');
    const formRef = ref();
    const form = ref({
      name: '',
      fullMoney: 0,
      disMoney: 0,
      category: '0',
      userWhitelist: '',
      singleCharge: {
        d: 'dayAmount',
        s: '>=',
        v: 0
      },
      singleConsume: {
        d: 'amount',
        s: '>=',
        v: 0
      },
      activeAmount: {
        d: 'cumulativeAmount',
        s: '>=',
        v: 0
      },
      record_use_benefit: 0,
      expire: 0,
      expireType: 1,
      rule: 1,
      limit: 0,
      benefitSize: 0,
      accountUrl: [],
      date: [],
      remark: ''
    });
    const confirmLoading = ref(false);
    const gameInfo = ref();
    const editStart = ref('');
    const editEnd = ref('');
    const compare = [{
      label: '<=',
      value: '<='
    }, {
      label: '>=',
      value: '>='
    }, {
      label: '=',
      value: '=='
    }];
    const keys = {
      name: 'name',
      category: 'category',
      userWhitelist: 'user_whitelist',
      expire: 'benefit_expire',
      benefitSize: 'benefit_size',
      remark: 'remark'
    };
    const handleClose = formEl => {
      if (!formEl) return;
      formEl.resetFields();
      initForm();
      dialogVisible.value = false;
    };
    const downloadTemplate = () => {
      const blob = new Blob(['账号1\n', '账号2\n', '账号3\n', '账号4\n'], {
        type: 'text/plain;charset=utf-8'
      });
      FileSaver.saveAs(blob, '模板.txt', {
        type: 'text/plain;charset=utf-8'
      });
    };
    // const range = (start: any, end: any) => {
    // 	const result = [];
    // 	for (let i = start; i < end; i++) {
    // 		result.push(i);
    // 	}
    // 	return result;
    // };
    const disabledRangeTime = date => {
      return date.getTime() < new Date().getTime();
    };
    const isStart = computed(() => {
      const [start, end] = form.value.date || ['', ''];
      if (start && end) {
        return Date.now() > dayjs(start).valueOf() || Date.now() > dayjs(end).valueOf();
      }
      return false;
    });
    const show = payload => {
      dialogVisible.value = true;
      type.value = payload.type;
      gameInfo.value = payload.gameInfo;
      if (payload.data) {
        const data = payload.data;
        const benefit = data.benefit_prop ? JSON.parse(data.benefit_prop) : null;
        const rules = data.rev_rules ? JSON.parse(data.rev_rules) : null;
        for (let key in keys) {
          form.value[key] = data[keys[key]];
        }
        form.value.id = data.id;
        // 起始日期
        console.log('act_begin_at', data.act_begin_at);
        form.value.date = [data.act_begin_at, data.act_end_at];
        editStart.value = data.act_begin_at;
        editEnd.value = data.act_end_at;
        if (benefit) {
          // 满减金额
          form.value.fullMoney = benefit.p.c.p;
          // 券面金额
          form.value.disMoney = benefit.p.e.p;
        }
        // 活动规则
        if (rules) {
          // 单日累充
          form.value.singleCharge = rules.c.find(item => item.d === 'dayAmount') || null;
          // 单笔消费
          form.value.singleConsume = rules.c.find(item => item.d === 'amount') || null;
          // 活动累充
          form.value.activeAmount = rules.c.find(item => item.d === 'cumulativeAmount') || null;
          // 领取张数
          form.value.limit = rules.c.find(item => item.d === 'limit').v;
          form.value.record_use_benefit = rules.record_use_benefit || 0;
        }
        if (form.value.singleCharge) {
          form.value.rule = 1;
          form.value.singleConsume = {
            d: 'amount',
            s: '>=',
            v: ''
          };
          form.value.activeAmount = {
            d: 'cumulativeAmount',
            s: '>=',
            v: ''
          };
        } else if (form.value.singleConsume) {
          form.value.rule = 2;
          form.value.singleCharge = {
            d: 'dayAmount',
            s: '>=',
            v: ''
          };
          form.value.activeAmount = {
            d: 'cumulativeAmount',
            s: '>=',
            v: ''
          };
        } else if (form.value.activeAmount) {
          form.value.rule = 3;
          form.value.singleConsume = {
            d: 'amount',
            s: '>=',
            v: ''
          };
          form.value.singleCharge = {
            d: 'dayAmount',
            s: '>=',
            v: ''
          };
        }
        // 发放人群
        form.value.accountUrl = data.benefit_acount_url ? [data.benefit_acount_url] : [];
        if (form.value.expire) {
          form.value.expireType = 2;
          form.value.expire = Math.floor(form.value.expire / 86400);
        }
      }
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (!valid) {
          return;
        }
        const formData = form.value;
        confirmLoading.value = true;
        const params = {
          id: formData.id,
          game: gameInfo.value.Id
        };
        for (let key in keys) {
          params[key] = formData[key];
        }
        if (formData.expireType == 2) {
          if (params.expire) {
            params.expire = Math.floor(params.expire * 86400);
          }
        } else {
          params.expire = '';
        }
        params.beginAt = formData.date[0];
        params.endAt = formData.date[1];
        if (formData.category == 0) {
          params.accountUrl = formData.accountUrl[0].url || formData.accountUrl[0];
        } else {
          console.log(formData.rule);
          // console.log(form.singleCharge);
          // console.log(form.singleConsume);
          const rule = formData.rule === 1 ? formData.singleCharge : formData.rule === 2 ? formData.singleConsume : formData.activeAmount;
          console.log(rule);
          params.revRules = JSON.stringify({
            ao: '&&',
            c: [rule, {
              d: 'limit',
              s: '<',
              v: formData.limit
            }],
            record_use_benefit: formData.record_use_benefit
          });
        }
        params.prop = JSON.stringify({
          p: {
            c: {
              p: formData.fullMoney,
              t: 'mt'
            },
            e: {
              p: formData.disMoney,
              t: 'r'
            }
          },
          t: 'c'
        });
        params.type = 'r'; // 满减券
        const api = type.value === 'add' ? apiUsdkAddVoucher : apiUsdkEditVoucher;
        api(params).then(res => {
          if (res.code === 0) {
            emits('success');
            handleClose(formRef.value);
          }
        }).finally(() => {
          confirmLoading.value = false;
        });
      });
    };
    const initForm = () => {
      form.value = {
        name: '',
        fullMoney: 0,
        disMoney: 0,
        category: '0',
        userWhitelist: '',
        singleCharge: {
          d: 'dayAmount',
          s: '>=',
          v: 0
        },
        singleConsume: {
          d: 'amount',
          s: '>=',
          v: 0
        },
        activeAmount: {
          d: 'cumulativeAmount',
          s: '>=',
          v: 0
        },
        record_use_benefit: 0,
        expire: 0,
        expireType: 1,
        rule: 1,
        limit: 0,
        benefitSize: 0,
        accountUrl: [],
        date: [''],
        remark: ''
      };
    };
    const formatDate = (rule, value, callback) => {
      if (!form.value.date[0] || !form.value.date[1]) {
        callback(new Error('请选择活动时间'));
      } else {
        callback();
      }
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_divider = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_input_number = __unplugin_components_3;
      const _component_el_radio = __unplugin_components_4;
      const _component_el_radio_group = __unplugin_components_5;
      const _component_el_option = __unplugin_components_6;
      const _component_el_select = __unplugin_components_7;
      const _component_el_form = __unplugin_components_8;
      const _component_el_button = __unplugin_components_9;
      const _component_el_dialog = __unplugin_components_10;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => dialogVisible.value = $event),
        title: `${type.value === 'add' ? '新增' : '编辑'}代金券`,
        width: "50%",
        "before-close": () => handleClose(formRef.value)
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_26, [_createVNode(_component_el_button, {
          onClick: _cache[21] || (_cache[21] = $event => handleClose(formRef.value))
        }, {
          default: _withCtx(() => [_hoisted_27]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[22] || (_cache[22] = $event => handleOk(formRef.value)),
          loading: confirmLoading.value,
          disabled: _unref(isStart)
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }, 8, ["loading", "disabled"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "代金券名称",
            prop: "name",
            rules: [{
              required: true,
              message: '请输入代金券名称',
              trigger: 'change'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
              placeholder: "10字符以内",
              maxlength: 10
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "满减金额",
            prop: "fullMoney",
            rules: {
              required: true,
              message: '请输入满减金额',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.value.fullMoney,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.fullMoney = $event),
              placeholder: "请输入金额",
              min: 0,
              max: 100000000
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "券面金额",
            prop: "disMoney",
            rules: {
              required: true,
              message: '请输入券面金额',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.value.disMoney,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.disMoney = $event),
              min: 0,
              max: form.value.fullMoney,
              placeholder: "请输入金额"
            }, null, 8, ["modelValue", "max"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "使用时间",
            prop: "expireType",
            rules: {
              required: true,
              message: '请选择使用时间',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.expireType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.expireType = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_hoisted_3, _createVNode(_component_el_input_number, {
                  modelValue: form.value.expire,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.expire = $event),
                  placeholder: "请输入整数",
                  min: 0
                }, null, 8, ["modelValue"]), _hoisted_4]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "发放方式",
            prop: "category",
            rules: {
              required: true,
              message: '请选择发放方式',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.category,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.category = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: "0"
              }, {
                default: _withCtx(() => [_hoisted_6]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: "1"
              }, {
                default: _withCtx(() => [_hoisted_7]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"]), _hoisted_8]),
            _: 1
          }), form.value.category === '0' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "发放人群",
            prop: "accountUrl",
            rules: {
              required: true,
              message: '请上传发放人群',
              trigger: 'blur'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(UUpload, {
              modelValue: form.value.accountUrl,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.accountUrl = $event),
              accept: ".txt",
              limit: 1
            }, null, 8, ["modelValue"]), _createElementVNode("span", {
              class: "marginL10",
              onClick: downloadTemplate,
              style: {
                "color": "#3F6DF8",
                "cursor": "pointer",
                "text-decoration": "underline"
              }
            }, "下载模板")])]),
            _: 1
          })) : _createCommentVNode("", true), form.value.category === '1' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_el_form_item, {
            label: "活动规则",
            prop: "rule",
            rules: {
              required: true,
              message: '请选择活动规则',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.rule,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.rule = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_hoisted_9]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_hoisted_10]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 3
              }, {
                default: _withCtx(() => [_hoisted_11]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), form.value.rule === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "单日累充",
            prop: "singleCharge",
            rules: {
              required: true,
              message: '请输入单日累充',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_select, {
              class: "width100px",
              modelValue: form.value.singleCharge.s,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.singleCharge.s = $event),
              placeholder: "选择条件"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compare.filter(item => item.value === '>='), (item, index) => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
              modelValue: form.value.singleCharge.v,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.singleCharge.v = $event),
              min: 0,
              max: 100000000,
              class: "width200px marginL10 marginR10",
              placeholder: "请输入整数"
            }, null, 8, ["modelValue"]), _hoisted_12]), _hoisted_13]),
            _: 1
          })) : _createCommentVNode("", true), form.value.rule === 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "单笔消费",
            prop: "singleConsume",
            rules: {
              required: true,
              message: '请输入单笔消费',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_select, {
              class: "width100px",
              modelValue: form.value.singleConsume.s,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.singleConsume.s = $event),
              placeholder: "选择条件"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(compare, (item, index) => {
                return _createVNode(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
              modelValue: form.value.singleConsume.v,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.singleConsume.v = $event),
              class: "width200px marginL10 marginR10",
              placeholder: "请输入整数"
            }, null, 8, ["modelValue"]), _hoisted_14]), _hoisted_15]),
            _: 1
          })) : _createCommentVNode("", true), form.value.rule === 3 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "活动累充",
            prop: "activeAmount",
            rules: {
              required: true,
              message: '请输入活动累充',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_select, {
              class: "width100px",
              modelValue: form.value.activeAmount.s,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.activeAmount.s = $event),
              placeholder: "选择条件"
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(compare, (item, index) => {
                return _createVNode(_component_el_option, {
                  key: index,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(_component_el_input_number, {
              modelValue: form.value.activeAmount.v,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.activeAmount.v = $event),
              class: "width200px marginL10 marginR10",
              placeholder: "请输入整数"
            }, null, 8, ["modelValue"]), _hoisted_16]), _hoisted_17]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "计费规则"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.record_use_benefit,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.record_use_benefit = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_hoisted_18]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 0
              }, {
                default: _withCtx(() => [_hoisted_19]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"]), _hoisted_20]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "白名单",
            prop: "userWhitelist"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.userWhitelist,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.userWhitelist = $event),
              type: "textarea",
              placeholder: "输入登录名，用,分割，（测试使用）",
              "auto-size": {
                minRows: 3,
                maxRows: 5
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "领取上限",
            prop: "limit",
            rules: {
              required: true,
              message: '请输入领取张数',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_hoisted_21, _createVNode(_component_el_input_number, {
              modelValue: form.value.limit,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.value.limit = $event),
              min: 0,
              max: 100000000,
              class: "width200px marginL10 marginR10",
              placeholder: "请输入整数"
            }, null, 8, ["modelValue"]), _hoisted_22, _hoisted_23]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "发放上限",
            prop: "benefitSize",
            rules: {
              required: true,
              message: '请输入发放数量',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input_number, {
              modelValue: form.value.benefitSize,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.value.benefitSize = $event),
              min: 0,
              max: 100000000,
              class: "width200px marginR10",
              placeholder: "请输入整数"
            }, null, 8, ["modelValue"]), _hoisted_24, _hoisted_25]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "使用详情",
            prop: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.remark,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.value.remark = $event),
              type: "textarea",
              placeholder: "输入使用详情",
              maxlength: 150,
              "auto-size": {
                minRows: 3,
                maxRows: 5
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "活动时间",
            prop: "date",
            rules: {
              required: true,
              validator: formatDate
            }
          }, {
            default: _withCtx(() => [_createVNode(DateRangePicker, {
              startValue: form.value.date[0],
              "onUpdate:startValue": _cache[19] || (_cache[19] = $event => form.value.date[0] = $event),
              endValue: form.value.date[1],
              "onUpdate:endValue": _cache[20] || (_cache[20] = $event => form.value.date[1] = $event),
              disabledDate: disabledRangeTime,
              valueFormat: "YYYY-MM-DD hh:mm:ss"
            }, null, 8, ["startValue", "endValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title", "before-close"]);
    };
  }
});